import { Add, AddBox, AddBoxOutlined, AddBusiness, AddCard, AddCircleOutline, AddOutlined, AddSharp, DeleteOutline, EditOutlined } from "@mui/icons-material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton, CustomButton, TableData } from "../../../../components";
import {
  removeDenomination,
  setCurrentDenomination,
  setDenominations,
} from "../../../../redux/slices/admin/denominationSlice";
import { confirmAlert, errorAlert } from "../../../../helpers/alerts";
import { addDenominationToBagsService, removeDenominationService, updateDenominationService } from "../../../../services/admin/denominationServices";
import { Grid } from "@mui/material";
import { validatePermission } from "../../../../helpers/authentication";
import { setLoading } from "../../../../redux/slices/uiSlice";
import { Box } from "@mui/system";

const DenominationScreen = () => {
  const dispatch = useDispatch();
  dispatch(setLoading(false));
  const navigate = useNavigate();
  const { denominations } = useSelector((store) => store.denominations);
  const { currentOperator } = useSelector((store) => store.operators);
  const { currentSegment } = useSelector((store) => store.segments);

  const handlerAdd = () => navigate("crear");

  const handlerEdit = (row) => {
    dispatch(setCurrentDenomination(row));
    navigate("editar");
  };

  const handlerExtra = (row) => {
    dispatch(setCurrentDenomination(row));
    navigate("extradenominaciones");
  }

  const handlerAddToBag = async (row) => {
    try {
      dispatch(setLoading(true));
      await addDenominationToBagsService(row.id)
    } catch (error) {

    } finally {

      dispatch(setLoading(false));
    }
  }

  const handlerCheck = async (row, currentValue) => {
    const data = { ...row, state: !currentValue }
    try {
      const response = await updateDenominationService(row.id, data);
      dispatch(setDenominations(response));
    }
    catch (error) {
      errorAlert(error);
    }
  };

  const handlerDelete = ({ id, denomination }) => {
    confirmAlert({
      title: "Estas seguro que deseas eliminar esta denominación?",
      text: `La denominación ${denomination} será eliminada.`,
      onConfirm: async () => {
        try {
          await removeDenominationService(id);
          dispatch(removeDenomination(id));
        }
        catch (error) {
          errorAlert(error);
        }
      }
    })
  };

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Recargas Celular</div>
          <div className="subtitle">Denominaciones</div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Box mt={-5} >
        <TableData
          dataRows={denominations}
          headerButtons={[
            validatePermission('productos', 'productos', ['agregar']) &&
            <CustomButton
              dark={true}
              icon={<AddOutlined />}
              key="addDenomination"
              name={"Denominación"}
              click={handlerAdd}
            />,
          ]}
          dataTitle={["Nombre", "Importe", "Vigencia", "Estado"]}
          formatter={({ denomination, imp, vig, state }) => [
            denomination,
            imp,
            vig,
            { type: "boolean", value: state, disabled: !validatePermission('productos', 'productos', ['editar']) },
          ]}
          onChecked={handlerCheck}
          actions={[
            validatePermission('productos', 'productos', ['editar']) &&
            {
              label: "Editar",
              icon: <EditOutlined />,
              onClick: (data) => {
                handlerEdit(data);
              },
            },
            validatePermission('productos', 'productos', ['ver', 'agregar', 'editar', 'eliminar']) &&
            {
              label: "Extras",
              icon: <Add />,
              onClick: (data) => {
                handlerExtra(data);
              }
            },
            validatePermission('productos', 'productos', ['ver', 'agregar', 'editar', 'eliminar']) &&
            {
              label: "Agregar a bolsas",
              icon: <AddCircleOutline />,
              validate: (data) => data.state,
              onClick: (data) => {
                handlerAddToBag(data);
              }
            },
            validatePermission('productos', 'productos', ['eliminar']) &&
            {
              label: "Eliminar",
              icon: <DeleteOutline />,
              onClick: (data) => {
                handlerDelete(data);
              },
            },
          ]}
        />
      </Box>
    </>
  );
};

export default DenominationScreen;
